import React from 'react';

import { GamesSearchGlobal } from '@interlayer/js/custom/components/main/GameSearchGlobal';

import { clsx } from '@interlayer/js/utils/classNames.util';

import style from '../FloatingButtons.scss';

export const GamesSearch = () => {
    return (
        <div className={clsx(style.item, style.isGamesSearch)}>
            <GamesSearchGlobal />
        </div>
    );
};
